function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '@homeaway/react-svg';
import { INFO__16 } from '@homeaway/svg-defs';
import Tooltip from '@homeaway/react-tooltip';
import "./BundleSize.css";

var BundleSize = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BundleSize, _Component);

  function BundleSize() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BundleSize.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        owner = _this$props.owner,
        repoName = _this$props.repoName,
        gzip = _this$props.gzip,
        local = _this$props.local;
    var trimmedName = name ? name.trim().replace(/ /g, '') : '';
    var treemapURL = local ? "treemap.html?name=" + trimmedName : "/discovery/component/" + owner + "/" + repoName + "/" + trimmedName + "/treemap";
    return /*#__PURE__*/React.createElement(Fragment, null, gzip && /*#__PURE__*/React.createElement(Tooltip, {
      centered: true,
      tooltipType: "tooltip--lg",
      interactiveContent: true,
      placement: "right",
      content: this.tooltipHTML
    }, /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      href: treemapURL
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: "BundleSize__SVGIcon text-muted",
      markup: INFO__16,
      inline: true
    }))));
  };

  _createClass(BundleSize, [{
    key: "tooltipHTML",
    get: function get() {
      var _this$props2 = this.props,
          raw = _this$props2.raw,
          parsed = _this$props2.parsed,
          gzip = _this$props2.gzip;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, 'Estimated size of gzipped bundle sent across the network. '), /*#__PURE__*/React.createElement("p", null, 'Click on the info icon to open a treemap of the files in the bundle. '), /*#__PURE__*/React.createElement("dl", {
        className: "BundleSize__dl"
      }, /*#__PURE__*/React.createElement("dt", {
        className: "BundleSize__dt text-white text-400"
      }, 'Gzipped:'), /*#__PURE__*/React.createElement("dd", {
        className: "BundleSize__dd"
      }, gzip + " bytes"), parsed && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("dt", {
        className: "BundleSize__dt text-white text-400"
      }, 'Parsed:'), /*#__PURE__*/React.createElement("dd", {
        className: "BundleSize__dd"
      }, parsed + " bytes")), raw && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("dt", {
        className: "BundleSize__dt text-white text-400"
      }, 'Raw:'), /*#__PURE__*/React.createElement("dd", {
        className: "BundleSize__dd"
      }, raw + " bytes"))));
    }
  }]);

  return BundleSize;
}(Component);

BundleSize.propTypes = {
  /** the name of the component */
  name: PropTypes.string,

  /** the name of the github owner of the repo containing the component */
  owner: PropTypes.string,

  /** the name of the repo containing the component */
  repoName: PropTypes.string,

  /** the size of the raw source code, in bytes */
  raw: PropTypes.number,

  /** the size of the minified bundle, in bytes */
  parsed: PropTypes.number,

  /** the size of the gzipped minified bundle, in bytes */
  gzip: PropTypes.number,

  /** true if running local documentation, false if Discovery docs */
  local: PropTypes.bool //

};
export default BundleSize;
//# sourceMappingURL=BundleSize.js.map